import basic from './basic'
import nav from './header'
import footer from './footer'
import home from './home'
import sendCode from './send-code'
import login from './login'
import createSellerAccount from './create-seller-account'
import sc from './seller-center'
import depositPaymentRecord from './marginrecord/deposit-payment-record'
import marginTurnover from './marginrecord/margin-turnover'
import marginAndDisclaimerInfo from './marginrecord/margin-and-disclaimer-info'
import flashSale from './flashSale'

export default {
  basic,
  nav,
  footer,
  home,
  sendCode,
  login,
  createSellerAccount,
  sc,
  depositPaymentRecord,
  marginTurnover,
  marginAndDisclaimerInfo,
  flashSale,
  languageName: {
    en: 'English - EN',
    zh: '简体中文 - ZH'
  }
}
